/* unplugin-vue-components disabled */import { render } from "./UserAvatar.vue?vue&type=template&id=527d6f92&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=527d6f92&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527d6f92"]])

export default __exports__